import { Button } from 'takeat-design-system-ui-kit';
import React, { useState, useRef } from 'react';
import toast from 'react-hot-toast';
import { CLUBE_METHOD } from '~/utils/consts';
import { printHtmlInIframe } from '~/services/printer/printerUtils';
import { fetchDataToPrint } from '~/services/printer/dataToPrint';
import { PaymentsPinpad } from '../PaymentsPinpad';
import { AreaSeparator } from '../styles';
import { Fiscal } from '../Fiscal';

import { StyledFooter } from './styles';

const BalconyPaymentTemplate = ({
  handleSelectedPaymentComponent,
  resetBalcony,
  storeNfce,
  handleStartPinpadPayment,
  clubInfo,
  setClubInfo,
  setBuyerName,
  buyerName,
  clientCashback,
  setClientCashback,
  banestesPayment,
  setBanestesPayment,
  paymentsSession,
  setPaymentsSession,
  setMetodoAndPaymentOption,
  left,
  setLeft,
  discount,
  discountPercent,
  value,
  setValue,
  paid,
  totalProduct,
  hasMoneyMethod,
  setModalDiscount,
  loadingPos,
  handleStoneTransactions,
  toggleCancelPos,
  modalCancelPos,
  setModalCancelPos,
  handleCancelStoneTransactions,
  allPaymentMethods,
  favoriteMethods,
  paymentMethods,
  checkStonePending,
  user,
  handleCheckIsBalconyOpen,
  formData,
  setFormData,
  makeOrder,
  setTypeSelected,
  totalDifference,
  setShowModalDifference,
  showShadow,
  loadingNfce,
  makingOrder,
  balconySession,
  savePaymentAsync,
  onCloseTableBill,
  onResetPinpadOperation,
  paymentsData,
  getPayments,
}) => {
  const [loading, setLoading] = useState(false);
  const totalToShow =
    parseFloat(
      balconySession?.session?.total_service_price?.replace(',', '.')
    ) || parseFloat(0);
  const [_, setPayments] = useState();
  const payments = paymentsData?.payments;
  const total_payments =
    parseFloat(paymentsData?.total_value?.replace(',', '.')) || parseFloat(0);
  const rest = parseFloat((totalToShow - total_payments).toFixed(2));
  const hasPinpadPayment = payments?.find(
    (payment) => payment?.channel === 'pinpad'
  );
  const hasCashbackPayment = payments?.find(
    (payment) => payment?.payment_method_id === CLUBE_METHOD
  );

  const iframeRef = useRef(null);
  const handleFetchDataToPrint = async (payload) => {
    try {
      const htmlResponse = await fetchDataToPrint(payload);
      printHtmlInIframe(iframeRef, htmlResponse);
    } catch (error) {
      toast.error('Erro ao buscar dados para impressão');
    }
  };

  return (
    <>
      <iframe ref={iframeRef} style={{ display: 'none' }} />

      <PaymentsPinpad
        handleSelectedPaymentComponent={() => {
          if (hasPinpadPayment) {
            toast.error(
              'Não é possível cancelar pedido feito pagamento com pinpad'
            );
            return;
          }
          if (hasCashbackPayment) {
            toast.error(
              'Não é possível cancelar pdido feito pagamento com cashback'
            );
            return;
          }

          handleSelectedPaymentComponent();
        }}
        rest={rest}
        totalToShow={totalToShow}
        getPayments={getPayments}
        setPayments={setPayments}
        total_payments={total_payments}
        payments={payments}
        onStartPinpadPayment={handleStartPinpadPayment}
        balconySession={balconySession}
        clubInfo={clubInfo}
        setClubInfo={setClubInfo}
        setBuyerName={setBuyerName}
        buyerName={buyerName}
        clientCashback={clientCashback}
        setClientCashback={setClientCashback}
        banestesPayment={banestesPayment}
        setBanestesPayment={setBanestesPayment}
        paymentsSession={paymentsSession}
        setPaymentsSession={setPaymentsSession}
        setMetodoAndPaymentOption={setMetodoAndPaymentOption}
        left={left}
        setLeft={setLeft}
        discount={discount}
        discountPercent={discountPercent}
        value={value}
        setValue={setValue}
        paid={paid}
        totalProduct={totalProduct}
        hasMoneyMethod={hasMoneyMethod}
        setModalDiscount={setModalDiscount}
        loadingPos={loadingPos}
        handleStoneTransactions={handleStoneTransactions}
        toggleCancelPos={toggleCancelPos}
        modalCancelPos={modalCancelPos}
        setModalCancelPos={setModalCancelPos}
        handleCancelStoneTransactions={handleCancelStoneTransactions}
        allPaymentMethods={allPaymentMethods}
        favoriteMethods={favoriteMethods}
        paymentMethods={paymentMethods}
        checkStonePending={checkStonePending}
        savePaymentAsync={savePaymentAsync}
        onResetPinpadOperation={onResetPinpadOperation}
      />

      <AreaSeparator />

      {user.has_nfce && (
        <Fiscal
          handleCheckIsBalconyOpen={handleCheckIsBalconyOpen}
          formData={formData}
          setFormData={setFormData}
          makeOrder={makeOrder}
          setTypeSelected={setTypeSelected}
          totalDifference={totalDifference}
          setShowModalDifference={setShowModalDifference}
        />
      )}
      <StyledFooter>
        <Button
          variant="outlined"
          children={user.has_nfce ? 'Emitir NF depois' : 'Pedir'}
          style={{
            fontFamily: 'Poppins',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '20px',
            letterSpacing: '0.1px',
            padding: '0 23px',
          }}
          onClick={async () => {
            if (rest > 0) {
              toast.error('Finalize o pagamento para realizar o pedido.');
              return;
            }

            setLoading(true);
            try {
              await onCloseTableBill().then(async () => {
                if (user.print_bills_on_web || user.is_printed_on_web) {
                  await handleFetchDataToPrint({
                    print_type: 'table_session',
                    table_session_id: balconySession.session.id,
                  });
                }
              });
            } finally {
              setLoading(false);
            }
            resetBalcony();
          }}
          isLoading={loadingNfce || makingOrder || loading}
          disabled={loadingNfce || makingOrder || loading}
        />

        {user.has_nfce && (
          <Button
            children="Emitir NFCe"
            style={{
              fontFamily: 'Poppins',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 600,
              lineHeight: '20px',
              letterSpacing: '0.1px',
              padding: '0 24px',
            }}
            onClick={async () => {
              if (rest > 0) {
                toast.error('Finalize o pagamento para realizar o pedido.');
                return;
              }

              setLoading(true);
              try {
                await onCloseTableBill().then(async () => {
                  await storeNfce();
                  if (user.print_bills_on_web || user.is_printed_on_web) {
                    await handleFetchDataToPrint({
                      print_type: 'table_session',
                      table_session_id: balconySession.session.id,
                    });
                  }
                });
              } finally {
                setLoading(false);
              }
              resetBalcony();
            }}
            isLoading={loadingNfce || makingOrder || loading}
            disabled={loadingNfce || makingOrder || loading}
          />
        )}
      </StyledFooter>
    </>
  );
};

export default BalconyPaymentTemplate;
